import rawConfig from "../config.json"

export interface SiteConfig {
  siteUrl: string
  analytics: {
    gaMeasurementId: string
  }
  adsense: {
    client: string
    inlineSlot: string
    sidebarSlot: string
  }
  contact: {
    email: string
    advertisingLabel: string
  }
  homepageCategories: string[]
}

export const siteConfig = rawConfig as SiteConfig

export const siteUrl = siteConfig.siteUrl.replace(/\/$/, "")
